import { useEffect } from 'react'
import { parseLiffFromRedirectUrl } from 'helpers/url'
import {
  serviceTypeSelector,
  isFixedServiceTypeSelector,
  setServiceType,
  resetServiceType,
  setIsFixedServiceType,
} from 'store/slices/buffetSlice'
import { useAppDispatch } from 'store'
import { useSelector } from 'react-redux'
import { LineItemServiceTypeForBuffetEnum } from 'graphQL/dinein/generate/operations'

const useServiceType = () => {
  const params = parseLiffFromRedirectUrl()
  const serviceTypeParam = params.get('service_type') ?? ''

  const serviceType = useSelector(serviceTypeSelector)
  const isFixedServiceType = useSelector(isFixedServiceTypeSelector)
  const dispatch = useAppDispatch()

  useEffect(() => {
    if (serviceTypeParam === LineItemServiceTypeForBuffetEnum.BuffetALaCarteTakeaway) {
      dispatch(setServiceType(LineItemServiceTypeForBuffetEnum.BuffetALaCarteTakeaway))
      dispatch(setIsFixedServiceType(true))
    }
  }, [serviceTypeParam, dispatch])

  const isEnableToggleUI = !isFixedServiceType

  return {
    isEnableToggleUI,
    serviceType,
    setServiceType: (val: LineItemServiceTypeForBuffetEnum) => dispatch(setServiceType(val)),
    resetServiceType: () => dispatch(resetServiceType()),
  }
}

export default useServiceType
